import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon} from "peggirkit";
import {PlusIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import {SetStateFn} from "@/utils/SetStateUtils";
import {EditDeliveryAreaState} from "@widgets/deliveryAreas/edit/EditDeliveryAreaModal";


type Props = {
    setEditModal: SetStateFn<EditDeliveryAreaState>,
};

const DeliveryAreasHeadingActions = ({setEditModal}: Props) => {
    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            <ActionRowButton
                color={"primary"}
                iconBefore={<Icon icon={PlusIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            setEditModal({showModal: true, deliveryArea: null});
                        },
                    }
                }}
            >
                <FormattedMessage id={"newDeliveryArea"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default DeliveryAreasHeadingActions;